import React from 'react';

const NotFound = () => {
  return (
    <div className="wrapper">
      <div className="not-found-container mtl mbl">
        <div className="not-found--error">404</div>
        <div className="not-found--summary mtl">This is not the page you were looking for.</div>
        <div className="not-found--text mtl">Sorry we've led you astray, now let's get you back on course.</div>
        <div className="not-found--inner mtl">
          <p>The page you requested cannot be found. It may have expired or been removed.</p>
          <ul>
            <li>If you reached this error page by typing an address into your web browser, please verify that the
              spelling and capitalization are correct and try reloading the page.
            </li>
            <li>You may wish to go back to the <a href="./" title="Home Page">Home Page</a>.</li>
          </ul>
        </div>
      </div>
    </div>
  )
};

export default NotFound;


// WEBPACK FOOTER //
// ./src/pages/NotFound.js